import React from 'react';
import styles from './EstateManage.module.scss';

/**
 * 소유주 인증 상태값을 UI용 레이블/클래스로 매핑
 *
 * ov_status (DB): null | DRAFT | PENDING | AWAITING_REVIEW | COMPLETED | FAILED | REJECTED
 * ov_expires_at:  인증 만료일 (COMPLETED 일 때)
 *
 * UI 상태 (key):  none | review | completed | expired | failed | rejected
 *  - PENDING, AWAITING_REVIEW → 모두 "검토중" (review)
 *  - COMPLETED + 만료일 지남  → "인증만료" (expired)
 */
export function getOvDisplay(ovStatus, ovExpiresAt) {
  if (!ovStatus || ovStatus === 'DRAFT') {
    return { key: 'none', label: '미인증', cls: styles.ovNone };
  }
  if (ovStatus === 'PENDING' || ovStatus === 'AWAITING_REVIEW') {
    return { key: 'review', label: '검토중', cls: styles.ovReview };
  }
  if (ovStatus === 'COMPLETED') {
    if (ovExpiresAt) {
      const now = new Date(); now.setHours(0,0,0,0);
      const expires = new Date(ovExpiresAt); expires.setHours(0,0,0,0);
      if (expires < now) {
        return { key: 'expired', label: '인증 만료', cls: styles.ovExpired };
      }
    }
    return { key: 'completed', label: '인증 완료', cls: styles.ovCompleted };
  }
  if (ovStatus === 'FAILED') {
    return { key: 'failed', label: '인증 실패', cls: styles.ovFailed };
  }
  if (ovStatus === 'REJECTED') {
    return { key: 'rejected', label: '인증 반려', cls: styles.ovRejected };
  }
  return { key: 'none', label: '미인증', cls: styles.ovNone };
}

/**
 * 인증완료(D-7) 갱신 필요 여부
 */
export function needsRenewal(ovStatus, ovExpiresAt) {
  if (ovStatus !== 'COMPLETED' || !ovExpiresAt) return false;
  const now = new Date(); now.setHours(0,0,0,0);
  const expires = new Date(ovExpiresAt); expires.setHours(0,0,0,0);
  const diff = Math.ceil((expires - now) / (1000 * 60 * 60 * 24));
  return diff >= 0 && diff <= 7;
}

export function getRenewalDaysLeft(ovExpiresAt) {
  if (!ovExpiresAt) return null;
  const now = new Date(); now.setHours(0,0,0,0);
  const expires = new Date(ovExpiresAt); expires.setHours(0,0,0,0);
  return Math.ceil((expires - now) / (1000 * 60 * 60 * 24));
}

/**
 * 테이블 뱃지 컴포넌트
 */
export default function OwnerVerificationBadge({ ovStatus, ovExpiresAt, onClick }) {
  const display = getOvDisplay(ovStatus, ovExpiresAt);

  return (
    <span
      className={`${styles.ovBadge} ${display.cls}`}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(display.key);
      }}
    >
      <span className={styles.ovDot} />
      {display.label}
    </span>
  );
}
